import { GuideStep } from "views/components/Guide";

import {
  CycleScene,
  ApproveScene,
  OtherActionsScene,
  SubmitScene,
  GoalScene,
} from "./art/ReviewScenes";

export const LP_REVIEW_GUIDE_STEPS: GuideStep[] = [
  {
    title: "Review in small batches",
    body: (
      <p>
        Each cycle labels what it is sure about and sends you the rest. Your
        answers improve the next cycle, and Label Propagation finishes on its
        own once it is confident enough, often before the review budget is used
        up.
      </p>
    ),
    tip: "The review budget is about 5 to 10% of the dataset. You will rarely review every image.",
    art: <CycleScene />,
  },
  {
    title: "Approve what is right",
    body: (
      <p>
        If the suggested label fits, click <strong>Approve</strong>.
      </p>
    ),
    tip: "Judge by the pink box: approve only if the defect is inside it. Click an image to zoom in before deciding.",
    art: <ApproveScene />,
  },
  {
    title: "Fix what is wrong",
    body: (
      <ul>
        <li>
          <strong>Reassign</strong> to another label.
        </li>
        <li>
          <strong>Ignore</strong> if it fits no label.
        </li>
        <li>
          <strong>Decline</strong> to send it to the next best label.
        </li>
      </ul>
    ),
    tip: "Ignored images get no label, move to Unlabeled, and do not count toward progress or the Train-Worthy Goal.",
    art: <OtherActionsScene />,
  },
  {
    title: "Submit the round",
    body: (
      <p>
        Review every image, then click <strong>Submit</strong>.{" "}
        <strong>Finish</strong> stops early and keeps labels so far.{" "}
        <strong>Reset</strong> deletes all progress.
      </p>
    ),
    art: <SubmitScene />,
  },
  {
    title: "Reach the Train-Worthy Goal",
    body: (
      <p>
        Each label needs 200 labeled images by default. Your Admin can change
        this number. At 100 percent you can send the dataset to{" "}
        <strong>Model Jobs</strong>.
      </p>
    ),
    tip: "Only propagated labels are used for training.",
    art: <GoalScene />,
  },
];
